import React from 'react'

import { LineChartWidget } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

type ActivityPoint = {
  label: string
  openedCount: number
  closedCount: number
}

type Props = {
  data: ActivityPoint[]
}

export const InsightsTicketActivityChart: React.FC<Props> = ({ data }) => {
  const chartData = data.map((point) => ({
    label: point.label,
    values: {
      opened: point.openedCount,
      closed: point.closedCount,
    },
  }))

  return (
    <LineChartWidget
      header={{
        title: i18n.t('ticketing.inbox.insights.charts.ticket_activity'),
      }}
      chart={{
        data: chartData,
        dataConfig: {
          opened: {
            label: i18n.t('ticketing.inbox.insights.charts.opened'),
            color: 'categorical-1',
          },
          closed: {
            label: i18n.t('ticketing.inbox.insights.charts.closed'),
            color: 'categorical-3',
          },
        },
      }}
    />
  )
}
